import { CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StorageLevelToCustomerLevelNamePipe, SystemMetadataService } from '@twaice-fe/frontend/shared/services';
import { Observable } from 'rxjs';
import { ChatDrawerService } from '../chat/chat-drawer.service';
import {
  ColumnItem,
  SystemOverviewAntTableInterface,
  SystemPortfolioOverviewViewModel,
} from './system-portfolio-overview-table-config';
import { SystemPortfolioOverviewTableService } from './system-portfolio-overview-table.service';

@Component({
  selector: 'twaice-fe-system-portfolio-overview-table',
  templateUrl: 'system-portfolio-overview-table.component.html',
  styleUrls: ['./system-portfolio-overview-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CurrencyPipe, StorageLevelToCustomerLevelNamePipe, SystemMetadataService, SystemPortfolioOverviewTableService],
  standalone: false,
})
export class SystemPortfolioOverviewTableComponent {
  readonly vm$: Observable<SystemPortfolioOverviewViewModel>;

  constructor(
    private tableService: SystemPortfolioOverviewTableService,
    private chatDrawerService: ChatDrawerService
  ) {
    this.vm$ = tableService.viewModel$;
  }

  trackColumn(_index: number, column: ColumnItem<SystemOverviewAntTableInterface>): string {
    return column.name;
  }

  navigate(data: SystemOverviewAntTableInterface, link: string): void {
    this.tableService.navigateToSystem(data, link);
  }

  openChat(customerBk: string, systemBk: string, systemName: string): void {
    this.chatDrawerService.openChatDrawer({ customerBk, systemBk, systemName });
  }
}
